import React from 'react';
import type { FeedTrade } from 'types/interfaces/feed';
import FeedPackageBlock from './FeedPackageBlock';

interface FeedPackagesViewProps {
  trades: FeedTrade[];
}

export const FeedPackagesView: React.FC<FeedPackagesViewProps> = ({ trades }) => (
  <div className="feed-packages-view">
    {trades.map((trade) => (
      <FeedPackageBlock key={trade.id} trade={trade} />
    ))}
  </div>
);

export default FeedPackagesView;
